import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=d058a48c&scoped=true&"
var script = {}
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=d058a48c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d058a48c",
  null
  
)

export default component.exports